/* eslint-disable @typescript-eslint/no-unused-vars */
import { createSlice, PayloadAction } from "@reduxjs/toolkit";
import { DeletePostRequest, DeletePostState } from "store/modules/posts/types";

const initialState: DeletePostState = {
    isRequesting: false,
    errors: []
};

const deletePostSlice = createSlice({
    name: "posts@deletePost",
    initialState,
    reducers: {
        deletePostRequest: (
            state,
            action: PayloadAction<DeletePostRequest>
        ): void => {
            state.isRequesting = true;
            state.errors = [];
        },
        deletePostSuccess: (
            state,
            action: PayloadAction<null>
        ): void => {
            state.isRequesting = false;            
        },
        deletePostFailed: (
            state,
            action: PayloadAction<string[]>
        ): void => {
            state.isRequesting = false;
            state.errors = action.payload;
        }
    }
});

export const {
    deletePostFailed,
    deletePostRequest,
    deletePostSuccess
} = deletePostSlice.actions;
export default deletePostSlice.reducer;
